export default "__VITE_ASSET__Dkqamq1I__"